// extracted by mini-css-extract-plugin
export var addButton = "_k8-0";
export var border = "_k8-8";
export var check = "_k8-h";
export var danger = "_k8-6";
export var dropdownContainer = "_k8-1";
export var editModalBody = "_k8-j";
export var footerContainer = "_k8-i";
export var fullWidth = "_k8-a";
export var hide = "_k8-9";
export var icon = "_k8-3";
export var input = "_k8-7";
export var inputFlex = "_k8-b";
export var inputWrapper = "_k8-c";
export var manualFocus = "_k8-5";
export var optionButton = "_k8-4";
export var pillWrapper = "_k8-e";
export var pointer = "_k8-2";
export var showOverflow = "_k8-f";
export var tagsFlex = "_k8-d";
export var xButton = "_k8-g";